import { Button, message, notification } from 'antd'
import { useEffect } from 'react'
import { errorResponse } from './errorResponse'
import { signOut } from 'firebase/auth'
import { useAuth, useFunctions } from 'reactfire'
import { useTranslation } from 'react-i18next'
import { api } from './api'

let acceptWasCalled = false

export default function useAcceptInvitation(
  searchParams,
  setSearchParams,
  successCallback
) {
  const auth = useAuth()
  const functions = useFunctions()
  const { t } = useTranslation()

  return useEffect(() => {
    if (acceptWasCalled) return
    acceptWasCalled = true
    // noinspection JSIgnoredPromiseFromCall
    acceptInvitationFromQueryString(
      searchParams,
      setSearchParams,
      successCallback,
      auth,
      functions,
      t
    )
    // Only execute once on mount
    // eslint-disable-next-line
  }, [])
}

async function acceptInvitationFromQueryString(
  searchParams,
  setSearchParams,
  successCallback,
  auth,
  functions,
  t
) {
  const clearInvitationParam = () => {
    searchParams.delete('invitation')
    searchParams.delete('mode')
    searchParams.delete('email')
    setSearchParams(searchParams)
  }

  async function acceptInvitationAction(invitation) {
    message.loading({
      content: t('frontend:invitations.accepting'),
      duration: 0,
      key: 'invitation',
    })
    const { contractUid } = await api(functions, 'invitations/accept', {
      invitation,
    })
    message.destroy('invitation')
    message.success(t('frontend:invitations.accepted'))
    clearInvitationParam()
    successCallback(contractUid)
  }

  if (searchParams.has('invitation')) {
    const invitation = searchParams.get('invitation')
    try {
      await acceptInvitationAction(invitation)
    } catch (error) {
      message.destroy('invitation')
      if (error.code) {
        switch (error.code) {
          case 'functions/not-found':
          case 'functions/invalid-argument':
            message.error(t('frontend:invitations.invalid'))
            clearInvitationParam()
            break
          case 'functions/failed-precondition':
            message.warning(t('frontend:invitations.alreadyAccepted'))
            clearInvitationParam()
            break
          case 'functions/permission-denied':
            if (error.message === 'EMAIL_MISMATCH') {
              const invitationEmail = error.details?.email
              notification.error({
                key: 'invitation-notification',
                message: t('frontend:invitations.otherAccountTitle'),
                description: (
                  <>
                    {t('frontend:invitations.emailMismatchDescription', {
                      invitationEmail,
                      currentEmail: auth?.currentUser?.email,
                    })}{' '}
                    <a href="mailto:support@cleverlohn.de">
                      support@cleverlohn.de
                    </a>
                    .
                  </>
                ),
                duration: 0,
                btn: (
                  <Button
                    block
                    danger
                    onClick={() => {
                      signOut(auth)
                      window.location.reload()
                    }}
                  >
                    {t('frontend:invitations.logout')}
                  </Button>
                ),
              })
            } else errorResponse(error)
            break
          default:
            errorResponse(error)
        }
      } else {
        errorResponse(error)
      }
    }
  }
}
